import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Grid,
  Typography,
  Chip,
  CardContent,
  Card,
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddBoxRounded';
import OnIcon from '@material-ui/icons/Visibility';
import OffIcon from '@material-ui/icons/VisibilityOff';
import {
  addAccountPayment,
  loadAccountHistory,
  changeVisibility
} from '../../../../store/accounts';

import { History } from '../';

import withAlert from '../../../../hoc/withAlert';

const Account = ({ account, setSnackMessage, setSnackType, setOpenSnack }) => {
  const dispatch = useDispatch();

  const [openAddForm, setOpenAddForm] = React.useState(false);
  const [openHistory, setOpenHistory] = React.useState(false);
  // const [accountId, setAccountId] = React.useState();
  const [amount, setAmount] = React.useState(0);
  const [comment, setComment] = React.useState('');

  const [history, setHistory] = React.useState([]);

  const handelOpenAddForm = () => {
    setOpenAddForm(true);
  };

  const handleCloseAddForm = () => {
    setOpenAddForm(false);
  };

  const handleAmountChange = event => {
    setAmount(event.target.value);
  };

  const handleCommentChange = event => {
    setComment(event.target.value);
  };

  const handelAddPayment = async () => {
    try {
      const result = await dispatch(
        addAccountPayment({ accountId: account.account_id, amount, comment })
      );

      if (result.type === 'api/callFailed') {
        setSnackMessage(`Ошибка: платеж не добавлен`);
        setSnackType('error');
        setOpenSnack(true);
      } else {
        setSnackMessage('Платеж добавлен');
        setSnackType('success');
        setOpenSnack(true);
      }
    } catch (error) {
      setSnackMessage(
        `Ошибка: ${error.response ? error.response.data.message : error}`
      );
      setSnackType('error');
      setOpenSnack(true);
    }

    setOpenAddForm(false);
  };

  const handelOpenHistory = async () => {
    setOpenHistory(true);
    await dispatch(loadAccountHistory({ accountId: account.account_id }));
  };

  const handleCloseHistory = () => {
    setOpenHistory(false);
  };

  const handelChangeVisibility = async () => {
    await dispatch(changeVisibility(account.account_id));
  };

  // UseEffects
  useEffect(() => {
    if (account.history) {
      setHistory(account.history);
    }
  }, [account]);

  return (
    <Fragment>
      <Dialog
        open={openAddForm}
        onClose={handleCloseAddForm}
        aria-labelledby="form-dialog-title">
        <form
          onSubmit={e => {
            e.preventDefault();
          }}>
          <DialogTitle id="form-dialog-title">{`${account.customer_surname} ${account.customer_name} добавить платеж`}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Если сумма платежа отрицательная - значит участник взял деньги в
              долг, если положительная вернул деньги
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="amount"
              label="Сумма платежа"
              type="number"
              fullWidth
              onChange={handleAmountChange}
            />
            <TextField
              id="comment"
              label="Комментарий"
              multiline
              rows={4}
              fullWidth
              onChange={handleCommentChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAddForm} color="primary">
              Отменить
            </Button>
            <Button
              type="submit"
              disabled={amount === 0}
              onClick={handelAddPayment}
              color="primary">
              Добавить
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        scroll="paper"
        fullScreen
        open={openHistory}
        onClose={handleCloseHistory}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{`${account.customer_surname} ${account.customer_name} история платежей`}</DialogTitle>
        <DialogContent>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="stretch"
            wrap="nowrap"
            spacing={2}>
            {history &&
              history.length > 0 &&
              history.map(h => (
                <Grid item key={h.id}>
                  {/* {h.id} */}
                  <History history={h} />
                </Grid>
              ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHistory} color="primary">
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>

      <Card>
        <CardContent
          style={{
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: 0
          }}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            spacing={0}
            style={{ padding: 10 }}
            wrap="nowrap">
            <Grid item>
              <Chip
                size="small"
                label={account.balance.toLocaleString('ru')}
                color={account.balance < 0 ? 'primary' : 'default'}
                onClick={handelOpenHistory}
              />
            </Grid>
            <Grid item>
              <IconButton onClick={handelOpenAddForm} style={{ padding: 8 }}>
                <AddIcon />
              </IconButton>
            </Grid>

            <Grid item>
              <IconButton
                onClick={handelChangeVisibility}
                style={{ padding: 8, paddingLeft: 0 }}>
                {account.visibility && (
                  <OnIcon  />
                )}
                {!account.visibility && (
                  <OffIcon  />
                )}
              </IconButton>
            </Grid>

            <Grid item xs zeroMinWidth>
              <Typography variant={'h5'} noWrap>
                {`${account.customer_id} ${account.customer_surname} ${account.customer_name}`}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Fragment>
  );
};

export default withAlert(Account);
